class Variants extends HTMLElement {
  constructor() {
    super();

    this.realSelect = this.querySelector('[data-real-select]');
    this.fakeOptions = [...this.querySelectorAll('[data-option]')];
  }

  connectedCallback() {
    this.fakeOptions.forEach((radio) => {
      radio.addEventListener('click', () => {
        const { value } = radio;
        this.realSelect.value = value;
      });
    });
  }
}

customElements.define('product-variants', Variants);
